<ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" style="margin-top: 0%;" color="#003478" size="medium"
    type="ball-spin-clockwise">
    <p style="font-size: 20px; font-family: Verdana,Arial,Helvetica,Trebuchet,_sans; color: black;">{{'Loading_DC_Info'|translate}}</p>
</ngx-spinner>
<div id="dataCollectionSection" style="margin-left: 2%;">
    <hr>
    <p class="head">{{'View_DC_Header'|translate}}</p>
    <hr>
    <br>
    <table cellspacing="0" cellpadding="2" class="lateststatus"
        *ngIf="dataCollectionAvailable == 'true'">
        <tbody>
            <tr>
                <th align="left">{{'Name'|translate}}</th>
                <th align="left">{{'Value'|translate}}</th>
            </tr>
            <tr *ngFor="let i of nameArray">
                <th style="font-weight: initial;" align="left">{{i[0]}}</th>
                <td>{{i[1]}}</td>
            </tr>
        </tbody>
    </table>
    <br>
    <table cellspacing="0" cellpadding="2" class="lateststatus"
        *ngIf="dataCollectionAvailable == 'true'">
        <tbody>
            <tr>
                <th align="left"><b>{{'Module'|translate}}</b></th>
                <th align="left">{{'Name'|translate}}</th>
                <th align="left">{{'Value'|translate}}</th>
            </tr>
            <tr *ngFor="let i of moduleNameArray">
                <td>{{i[0]}}</td>
                <td>{{i[1]}}</td>
                <td>{{i[2]}}</td>
            </tr>
        </tbody>
    </table>
    <p *ngIf="dataCollectionAvailable == 'false'" style="font-weight: bold; color: #003F87;">{{'DC_Info_NotAvailable_Msg'|translate}}.</p>
</div>